import React, {useState} from "react";
import {LoaderFunctionArgs, useLoaderData, useParams} from "react-router-dom";
import axios from "axios";
import {Snackbar} from "@mui/material";
import CabinDataGrid from "../components/CabinDataGrid";
import {SleepingAssignment} from "../../../server/Plot";

export interface CabinAssignment {
    id: number
    playerName : string
    characterName : string
    requested: boolean | null
    assigned: boolean | null
}

interface CabinsLoaderData {
    assignments: CabinAssignment[]
    locations: SleepingAssignment[]
}

export const cabinsLoader = async ({params}: LoaderFunctionArgs): Promise<CabinsLoaderData> => {
    if (!params.eventId) return {assignments: [], locations: []}
    const [assignmentsRes, locationsRes] = await Promise.all([
        axios.get(`/api/events/${params.eventId}/cabin/`),
        axios.get(`/api/events/${params.eventId}/site/assignments`),
    ])
    return {assignments: assignmentsRes.data, locations: locationsRes.data}
}

export default function CabinAssignments() {
    const {eventId} = useParams<{eventId: string}>()
    const loaderData = useLoaderData() as CabinsLoaderData
    const [assignments, setPayments] = useState(loaderData.assignments);
    const [open, setOpen] = React.useState(false);

    const saveAssignment = async (p : CabinAssignment) => {
        const apiEndpoint = `/api/events/${eventId}/cabin/` + p.id
        await axios.post(apiEndpoint,p).then(({data}) => {
            setOpen(true)
        })
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <React.Fragment>
            <CabinDataGrid assignments={assignments} locations={loaderData.locations} onEdit={saveAssignment}/>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Payment Updated"
            />
        </React.Fragment>
    )
}